<template>
    <div>
        <dx-grid
            url="smsPendingMessages"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :onLoaded="mapResults"
            :selectionEnabled="true"
            :actions="actions"
            ref="grid"
        ></dx-grid>

        <v-dialog persistent v-model="unknownAccountDialog" max-width="700">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Assign Account / Reply -
                    {{ unknownAccount.accountID }}</v-card-title
                >
                <div
                    class="account-messages-grid-scroll-down elevation-0"
                    style="background-color: #f1ffdc"
                >
                    <v-timeline class="petition-timeline mx-3" style="">
                        <div v-for="message in unknownAccountMessages">
                            <v-timeline-item
                                v-if="message.direction == 'INC'"
                                color="blue lighten-2"
                                right
                            >
                                <v-card>
                                    <v-card-title class="py-1 blue lighten-2">
                                        <h2
                                            class="body-1 my-0 white--text font-weight-light"
                                        >
                                            <div>
                                                <v-icon
                                                    dark
                                                    size="15"
                                                    class="mr-2"
                                                >
                                                    mdi-cellphone
                                                </v-icon>
                                                {{ message.dateTime | time }}
                                            </div>
                                            <div>
                                                {{
                                                    formatPhoneNumber(
                                                        message.from,
                                                    )
                                                }}
                                            </div>
                                        </h2>
                                    </v-card-title>
                                    <v-container class="pa-2">
                                        <v-layout class="px-2 pt-1">
                                            <v-flex
                                                xs10
                                                class="py-0 body-2 account-message-text"
                                            >
                                                {{ message.text }}
                                            </v-flex>
                                        </v-layout>
                                        <v-layout
                                            class="mark-as-completed-tooltip"
                                            row
                                            justify-end
                                            style="font-size: 11px"
                                        >
                                            <v-spacer></v-spacer>
                                            <div
                                                v-if="
                                                    message.status != 'PENDING'
                                                "
                                                class="text-xs-right px-2 account-message-status account-message-status-completed"
                                            >
                                                READ
                                            </div>
                                            <v-tooltip
                                                style="opacity: 1 !important"
                                                min-width="275"
                                                v-if="
                                                    message.status == 'PENDING'
                                                "
                                                :value="
                                                    messageTooltip.includes(
                                                        message.id,
                                                    )
                                                "
                                                top
                                            >
                                                <template
                                                    v-slot:activator="{ on }"
                                                >
                                                    <!-- <v-btn color="primary" dark v-on="on">Left</v-btn> -->
                                                    <div
                                                        v-on:click="
                                                            openMarkCompletedTooltip(
                                                                message,
                                                            )
                                                        "
                                                        class="text-xs-right px-2 account-message-status account-message-status-pending"
                                                    >
                                                        {{ message.status }}
                                                    </div>
                                                </template>
                                                <div
                                                    class="pt-2"
                                                    @mouseleave="
                                                        closeTooltip(message)
                                                    "
                                                >
                                                    <span
                                                        class="tooltip-title mt-2"
                                                        >MARK AS READ?</span
                                                    >
                                                    <v-layout
                                                        row
                                                        justify-center
                                                        class="mt-4 mb-2"
                                                    >
                                                        <v-btn
                                                            small
                                                            color="#aeb8bf"
                                                            :disabled="
                                                                processing
                                                            "
                                                            @click="
                                                                markAsCompleted(
                                                                    message,
                                                                )
                                                            "
                                                            class="mr-3 mb-0 mark-message-button"
                                                            >Mark This</v-btn
                                                        >
                                                        <v-btn
                                                            small
                                                            color="#aeb8bf"
                                                            :disabled="
                                                                processing
                                                            "
                                                            @click="
                                                                markAsCompleted(
                                                                    message,
                                                                    true,
                                                                )
                                                            "
                                                            class="mb-0 mark-message-button"
                                                            >Mark All</v-btn
                                                        >
                                                    </v-layout>
                                                </div>
                                            </v-tooltip>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                            </v-timeline-item>
                            <v-timeline-item
                                v-if="message.direction == 'OUT'"
                                color="rgb(92, 184, 96)"
                                left
                            >
                                <v-card>
                                    <v-card-title
                                        style="background-color: rgb(92, 184, 96)"
                                        class=" py-1"
                                    >
                                        <h2
                                            class="body-1 my-0 white--text font-weight-light"
                                        >
                                            <div>
                                                <v-icon
                                                    dark
                                                    size="15"
                                                    class="mr-2"
                                                >
                                                    mdi-laptop-windows
                                                </v-icon>
                                                {{ message.dateTime | time }}
                                            </div>
                                            <div>
                                                {{
                                                    message.username +
                                                        " - " +
                                                        formatPhoneNumber(
                                                            message.from,
                                                        )
                                                }}
                                            </div>
                                        </h2>
                                    </v-card-title>
                                    <v-container class="pa-2">
                                        <v-layout class="px-2 pt-1">
                                            <v-flex
                                                xs10
                                                class="py-0 body-2 account-message-text"
                                            >
                                                {{ message.text }}
                                            </v-flex>
                                        </v-layout>
                                        <v-layout
                                            row
                                            justify-end
                                            style="font-size: 11px"
                                        >
                                            <v-spacer></v-spacer>
                                            <div
                                                class="text-xs-right px-2 account-message-status"
                                                style=""
                                            >
                                                {{ message.smsStatus }}
                                            </div>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                            </v-timeline-item>
                        </div>
                    </v-timeline>
                </div>
                <v-divider></v-divider>
                <v-layout row class="mx-1 mt-1">
                    <v-textarea
                        class="mr-2"
                        hide-details
                        label="Type a Message..."
                        v-model="newMessage"
                        ref="newMessage"
                        rows="1"
                    ></v-textarea>
                    <v-btn
                        @click="sendMessage()"
                        :disabled="disableSend()"
                        :loading="sending"
                        color="success"
                    >
                        <v-icon>mdi-send</v-icon>
                    </v-btn>
                </v-layout>
                <div
                    class="pa-3"
                    style="border: 2px solid #4caf50; border-radius: 3px"
                >
                    <div class="subheading mb-2">
                        Select Account ID
                    </div>
                    <v-autocomplete
                        class="mb-3"
                        hide-details
                        label="Account ID"
                        placeholder="Start typing..."
                        hide-no-data
                        ref="newAccountID"
                        v-model="newAccountID"
                        :items="accounts"
                        :search-input.sync="loadAccounts"
                    ></v-autocomplete>
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeUnknownDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveUnknownAccount()"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="markAsReadDialog" max-width="600">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Mark As Read</v-card-title
                ><v-card-text class="py-0 pb-3 pl-0 font-weight-medium"
                    >The messages bellow will be marked as read</v-card-text
                >
                <v-layout row class="font-weight-medium">
                    <div style="width: 250px;">Name</div>
                    <div>Message</div>
                </v-layout>
                <v-divider class="mt-2 pb-2"></v-divider>
                <div v-for="(message, index) in selectedMessages">
                    <v-layout row>
                        <div style="width: 250px;">{{ message.name }}</div>
                        <div>
                            {{ truncate(message.text) }}
                        </div>
                    </v-layout>
                    <v-divider
                        class="mt-2 pb-2"
                        v-if="index + 1 < selectedMessages.length"
                        :key="index"
                    ></v-divider>
                </div>
                <v-card-actions class="mx-0 px-2 pb-2 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="markAsReadDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        :disabled="!selectedMessages.length"
                        @click="markAsRead()"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="imageViewDialog" max-width="800">
            <v-card>
                <div v-for="image in clickedRow.images">
                    <v-img :src="image"></v-img>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { formatPhoneNumber, truncate } from "../../utils/helpers.js";
import * as firebase from "firebase/app";
import "firebase/database";

export default {
    data: () => ({
        title: "Pending Messages",
        imageViewDialog: false,
        clickedRow: "",

        columns: [
            {
                label: "Account ID",
                field: "accountID",
                template: "link-action-cell-template",
                format: "",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "NameH",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "dateTime",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(3, "day")
                        .add(1, "day"),
                ),
                selectedFilterOperation: ">=",
            },
            {
                label: "From",
                field: "from",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "To",
                field: "to",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Message",
                field: "text",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Attachment",
                field: "attachment",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                template: "link-action-cell-template",
                showLink: (row) => {
                    return row.attachmentUrls;
                },
            },
            {
                label: "Home Phone",
                field: "homePhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "CellPhone",
                field: "cellPhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Message Type",
                field: "messageType",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Email",
                field: "emailAddress",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        unknownAccountDialog: false,
        markAsReadDialog: false,
        newMessage: "",
        unknownAccount: "",
        unknownAccountMessages: [],
        newAccountID: "",
        accounts: [],
        loadAccounts: null,
        processing: false,
        sending: false,
        messageTooltip: [],
        selectedMessages: [],

        intervalID: "",

        actions: [],

        incomingMessagesRef: "",

        lastMessageNotifications: [],

        lastNotificationAt: "",
    }),
    watch: {
        async loadAccounts(value) {
            if (!value) return;

            const response = await this.$http.get(
                "api/accounts/getAccountIDs?value=" + value,
            );

            this.accounts = response;
        },
    },
    created() {
        this.columns.find(
            (c) => c.field == "accountID",
        ).linkAction = this.onAccountIDClick;

        this.columns.find((c) => c.field == "attachment").linkAction = (
            message,
        ) => {
            const clickedRow = message;

            clickedRow.images = clickedRow.attachmentUrls.split(";");

            this.clickedRow = clickedRow;

            this.imageViewDialog = true;
        };

        this.actions.push({
            text: "Mark as Read",
            action: this.openMarkAsReadDialog,
            showOnSelection: true,
        });
    },
    mounted() {
        this.refreshTimer = setInterval(() => {
            if (this.$refs.grid) {
                this.$refs.grid.reloadGrid();
            }
        }, 5 * 60 * 1000);

        if (this.$refs && this.$refs.grid) {
            this.firebaseSetup();
            //this.setup();
        }

        document.addEventListener("DOMContentLoaded", function() {
            if (!Notification) {
                alert(
                    "Desktop notifications not available in your browser. Try google chrome.",
                );
                return;
            }

            if (Notification.permission !== "granted")
                Notification.requestPermission();
        });
    },
    beforeDestroy() {
        clearInterval(this.refreshTimer);
        clearInterval(this.intervalID);

        if (this.incomingMessagesRef && this.incomingMessagesRef.off) {
            this.incomingMessagesRef.off();
        }
    },
    methods: {
        onAccountIDClick(row) {
            this.onRowClicked(row);
        },
        async onRowClicked(row) {
            if (!row.accountID.startsWith("CallerID")) {
                this.$router.push({
                    name: "Account View",
                    params: {
                        id: row.accountID,
                    },
                    query: {
                        goToMessageSection: true,
                    },
                });

                return;
            }

            this.unknownAccount = row;

            await this.loadUnknownAccountMessages();

            this.intervalID = setInterval(
                this.loadUnknownAccountMessages,
                30000,
            );

            this.newAccountID = "";
            this.unknownAccountDialog = true;
        },
        mapResults(results) {
            return results.map((sms) => {
                sms.attachment = sms.attachmentUrls ? "Attachment" : "";

                return sms;
            });
        },
        firebaseSetup() {
            const firebaseConfig = {
                apiKey: "AIzaSyCtYeCL8HkqlMKJh6g6jcDvoH60-woVbDE",
                authDomain: "utaw.firebaseapp.com",
                databaseURL: "https://utaw.firebaseio.com",
                projectId: "project-683582246459980907",
                storageBucket: "project-683582246459980907.appspot.com",
                messagingSenderId: "193425158146",
                appId: "1:193425158146:web:f1ae134a803fb75832371b",
            };

            // Initialize Firebase
            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            var incomingMessagesRef = firebase
                .database()
                .ref("incoming-messages");

            this.incomingMessagesRef = incomingMessagesRef;

            this.incomingMessagesRef.on(
                "child_changed",
                this.onChildChanged,
                function(error) {
                    console.log("Error: " + error.code);
                },
            );
        },
        onChildChanged(snapshot) {
            const lastUpdated = snapshot.val().LastUpdated;

            if (this.lastNotificationAt == lastUpdated) return;

            this.lastNotificationAt = lastUpdated;

            if (!snapshot.val().PendingCount) return;

            this.newMessageNotification(snapshot.val());
        },
        async newMessageNotification(snapshot) {
            if (Notification.permission !== "granted")
                Notification.requestPermission();
            else {
                try {
                    const response = await this.$http.get(
                        "api/broadcast/getMessagesWithAccountInfo?accountID=" +
                            snapshot.AccountID,
                    );

                    if (!response.messages.length) return;

                    const incomingMessages = response.messages.filter(
                        (m) => m.direction == "INC",
                    );
                    const lastMessage =
                        incomingMessages[incomingMessages.length - 1];

                    const date = moment().subtract(2, "minutes");
                    const twoMinutesAgo = Date.parse(date);

                    if (
                        !this.lastMessageNotifications.includes(lastMessage.id)
                    ) {
                        this.lastMessageNotifications.push(lastMessage.id);

                        new Notification(
                            "New Message from " + response.account
                                ? response.account.name
                                : lastMessage.from,
                            {
                                icon:
                                    "https://utaw.blob.core.windows.net/images/logo+uta11.png",
                                body: lastMessage.text,
                            },
                        );
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        },
        async loadUnknownAccountMessages() {
            this.unknownAccountMessages = await this.$http.get(
                "api/broadcast/getAccountMessages?accountID=" +
                    this.unknownAccount.accountID,
            );
        },
        async sendMessage() {
            const lastMessage = this.unknownAccountMessages[
                this.unknownAccountMessages.length - 1
            ];

            this.sending = true;

            try {
                await this.$http.post("api/broadcast/sendMessageToAccount", {
                    from:
                        lastMessage.direction == "INC"
                            ? lastMessage.to
                            : lastMessage.from,
                    to:
                        lastMessage.direction == "INC"
                            ? lastMessage.from
                            : lastMessage.to,
                    accountId: null,
                    text: this.newMessage,
                    username: this.$store.state.authentication.user,
                });

                await this.loadUnknownAccountMessages();

                this.newMessage = "";

                this.sending = false;
            } catch (e) {
                this.sending = false;
            }
        },
        disableSend() {
            return !this.newMessage
                .replace(/\r\n/g, "<br />")
                .replace(/[\r\n]/g, "");
        },
        closeUnknownDialog() {
            this.accounts = [];
            this.newAccountID = "";
            this.unknownAccountDialog = false;

            clearInterval(this.intervalID);
        },
        async saveUnknownAccount() {
            if (this.newAccountID) {
                this.processing = true;

                try {
                    await this.$http.post("api/broadcast/assignAccount?", {
                        fromAccount: this.unknownAccount.accountID,
                        accountID: this.newAccountID,
                        type: "SMS",
                    });

                    this.processing = false;
                } catch (e) {
                    this.processing = false;
                }
            }

            this.accounts = [];
            this.newAccountID = "";
            this.unknownAccountDialog = false;

            this.$refs.grid.reloadGrid();
        },
        openMarkCompletedTooltip(message) {
            if (!this.messageTooltip.includes(message.id)) {
                this.messageTooltip.push(message.id);
            }
        },
        closeTooltip(message) {
            const element = this.messageTooltip.find((m) => m == message.id);

            if (!element) return;

            const index = this.messageTooltip.indexOf(element);

            this.messageTooltip.splice(index, 1);
        },
        openMarkAsReadDialog() {
            this.selectedMessages = this.$refs.grid.getSelectedRowsData();

            this.markAsReadDialog = true;
        },
        async markAsCompleted(message, all = false) {
            this.processing = true;

            try {
                await this.$http.post(
                    "api/smsPendingMessages/markAsCompleted",
                    {
                        messageID: message.id,
                        accountID: this.unknownAccount.accountID,
                        markAll: all,
                    },
                );

                this.processing = false;

                this.loadUnknownAccountMessages();

                this.closeTooltip(message);
            } catch (e) {
                this.processing = false;
            }
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        formatPhoneNumber(number) {
            const value = number.length == 11 ? number.substring(1) : number;

            return formatPhoneNumber(value);
        },
        truncate(text) {
            return truncate(text, 40);
        },
        async markAsRead() {
            this.processing = true;

            try {
                await this.$http.post(
                    "api/smsPendingMessages/markAccountsAsCompleted",
                    this.selectedMessages.map((m) => m.accountID),
                );

                this.processing = false;
                this.markAsReadDialog = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async setup() {
            const messages = await this.$refs.grid.loadAll();

            const incomingMessages = messages.filter(
                (m) => m.direction == "INC",
            );

            const lastIncomingMessage =
                incomingMessages[incomingMessages.length - 1];

            if (lastIncomingMessage) {
                this.lastMessageNotifications.push(lastIncomingMessage.id);
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.petition-timeline .v-timeline-item {
    padding-bottom: 15px !important;
}
.account-messages-grid-scroll-down {
    overflow-y: auto;
    height: 200px;
    display: flex;
    flex-direction: column-reverse;
}
.account-message-text {
    white-space: pre-line;
    margin-top: -20px;
}
.account-message-status {
    width: fit-content;
    background-color: purple;
    color: #fff;
    font-size: 11px;
    text-transform: uppercase;
}

.account-message-status-pending {
    background-color: rgb(253, 180, 0);
    cursor: pointer;
}

.account-message-status-completed {
    background-color: rgb(92, 184, 96);
}

.mark-as-completed-tooltip .v-tooltip__content {
    pointer-events: auto !important;
    background: #eef2f5 !important;
    border: 1px solid #ced9e2 !important;
}

.mark-message-button {
    font-weight: 600 !important;
    font-size: 14px !important;
    color: #fff;
}

.mark-message-button:hover {
    background-image: none !important;
    background-color: #f35123 !important;
    color: #fff !important;
}
</style>
